import { styled, component } from '../../../utils/style';

export interface StyledDriveItemFavoriteIconProps {
	isCard: boolean;
	fillColor: string;
	strokeColor: string;
	needBottomPadding?: boolean;
}

export const StyledDriveItemFavoriteIcon = styled<StyledDriveItemFavoriteIconProps>()(component.span, 'StyledDriveItemFavoriteIcon')`
	cursor: pointer;
	height: 30px;
	width: 30px;
	${ props => props.isCard
		? `position: absolute;
		bottom: 5px;
		left: 5px;`
		: ''
	}

	& > svg {
		height: 30px;
		width: 30px;
		transition: all 0.2s;
		fill: ${props => props.fillColor}!important;
		padding-bottom: ${props => props.needBottomPadding ? '4px' : '0px'};

		${ props => props.isCard
			 ? `stroke: ${props.strokeColor};
				stroke-width: 0.7px;`
			 : ''
		}
`;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Favorites/favoriteIcon/styles.ts